import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  fallbackLng: "en",
  lng: "pt-BR",
  resources: {
    en: {
      translations: require("./en.json"),
    },
    "pt-BR": {
      translations: require("./pt-br.json"),
    },
  },
  ns: ["translations"],
  defaultNS: "translations",
});

i18n.languages = ["en", "pt-BR"];

export default i18n;
